<div class="fleet-vehicle-found-layout" *ngIf="host.notification?.type === 'fleet-vehicle-found'">
  <div class="fleet-vehicle-found-layout__meta">
    <div class="fleet-vehicle-found-layout__meta-row">
      <div class="form-group fleet-vehicle-found-layout__meta-item">
        <label for="license-plate-fleet-found">License plate</label>
        <p class="appointment-p" id="license-plate-fleet-found">
          {{ host.notification?.data?.plate }}
        </p>
      </div>
      <div class="form-group fleet-vehicle-found-layout__meta-item">
        <label for="last-washed-date-fleet-found">Last washed</label>
        <p class="appointment-p" id="last-washed-date-fleet-found">
          {{ host.getFormattedLastWashedDate() }}
        </p>
      </div>
    </div>
  </div>

  <section
    class="order-request-section order-request-services fleet-vehicle-found-layout__services"
  >
    <app-order-request-packages-block
      [host]="host"
      radioName="package-radio-fleet-found"
      customPriceIdPrefix="single-wash-price-fleet-"
    />

    <div
      class="form-group order-request-static-group"
      *ngIf="host.showOrderRequestPrepaidRedemptionSection()"
    >
      <label class="order-request-subsection-label">
        Prepaid redemption
        <span
          *ngIf="host.getOrderRequestPrepaidRedemptionStatusBadge() === 'active'"
          class="order-request-prepaid-active-badge"
          >Active</span
        >
        <span
          *ngIf="host.getOrderRequestPrepaidRedemptionStatusBadge() === 'expired'"
          class="order-request-prepaid-expired-badge"
          >Expired</span
        >
      </label>
      <app-order-request-prepaid-cards
        [host]="host"
        [loading]="host.isLoadingOrderRequestPrepaid || host.isLoadingPrepaidPurchaseStatus"
      />
      <app-prepaid-redemption
        class="order-request-prepaid-redemption-panel"
        [status]="host.prepaidPurchaseStatus"
        [loading]="host.isLoadingPrepaidPurchaseStatus"
        [error]="host.prepaidPurchaseStatusError"
        [redeemedSlots]="host.prepaidRedemptionSlots"
        [loadingRedemptions]="host.isLoadingPrepaidRedemptions"
        [redemptionsError]="host.prepaidRedemptionsError"
        [selectedSlotKeys]="host.orderRequestRedemptionSlotKeys"
        [recipient]="host.prepaidRedemptionRecipient"
        [plateError]="host.prepaidRedemptionPlateError"
        [phoneError]="host.prepaidRedemptionPhoneError"
        [emailError]="host.prepaidRedemptionEmailError"
        [firstNameError]="host.prepaidRedemptionFirstNameError"
        [lastNameError]="host.prepaidRedemptionLastNameError"
        [phoneSearchResults]="host.recipientPhoneSearchResults"
        [showPhoneDropdown]="host.showRecipientPhoneDropdown"
        [isSearchingPhone]="host.isSearchingRecipientByPhone"
        (selectionChange)="host.onOrderRequestRedemptionSelectionChange($event)"
        (recipientChange)="host.onPrepaidRedemptionRecipientChange($event)"
        (recipientFieldTouched)="host.onPrepaidRedemptionRecipientFieldTouched()"
        (recipientPlateInput)="host.onRecipientPlateSearchInput($event)"
        (recipientPhoneInput)="host.onRecipientPhoneSearchInput($event)"
        (recipientPhoneSearchSelect)="host.selectRecipientFromPhoneSearch($event)"
        (recipientPhoneBlur)="host.hideRecipientPhoneDropdown()"
        (retryLoad)="host.retryLoadPrepaidPurchaseStatus()"
        (redemptionTabOpened)="host.onPrepaidRedemptionTabOpened()"
        (retryLoadRedemptions)="host.retryLoadPrepaidRedemptions()"
      />
    </div>

    <div
      class="form-group order-request-static-group"
      *ngIf="host.showOrderRequestPrepaidSection()"
    >
      <label class="order-request-subsection-label order-request-subsection-label--group"
        >Prepaid</label
      >
      <app-order-request-prepaid-cards
        [host]="host"
        [loading]="host.isLoadingOrderRequestPrepaid"
        [selectable]="true"
      />
    </div>

    <div class="form-group order-request-static-group" *ngIf="host.showOrderRequestFleetSection">
      <label class="order-request-subsection-label">Fleet</label>
      <div
        class="order-request-static-cards"
        *ngIf="!host.isLoadingOrderRequestFleets; else fleetFoundFleetLoading"
      >
        <div
          class="order-request-static-card order-request-static-card--selectable"
          *ngFor="let f of host.orderRequestFleets"
          [class.order-request-static-card--selected]="host.isOrderRequestFleetSelected(f.id)"
          [class.order-request-static-card--disabled]="host.isOrderRequestFleetSelectionLocked()"
          (click)="host.selectOrderRequestFleet(f.id, $event)"
          role="radio"
          [attr.aria-checked]="host.isOrderRequestFleetSelected(f.id)"
          [attr.aria-disabled]="host.isOrderRequestFleetSelectionLocked()"
          [attr.tabindex]="host.isOrderRequestFleetSelectionLocked() ? -1 : 0"
          (keydown.enter)="host.selectOrderRequestFleet(f.id, $event)"
          (keydown.space)="host.selectOrderRequestFleet(f.id, $event)"
        >
          <span class="order-request-static-card__title" [attr.title]="f.label">{{ f.label }}</span>
        </div>
      </div>
      <ng-template #fleetFoundFleetLoading>
        <ng-container *ngTemplateOutlet="host.orderRequestCardsShimmer"></ng-container>
      </ng-template>
    </div>
  </section>

  <ng-template #host.orderRequestCardsShimmer>
    <div
      class="order-request-cards-shimmer order-request-static-cards"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div
        *ngFor="let _ of host.orderRequestSectionShimmerSlots"
        class="order-request-cards-shimmer__card"
        aria-hidden="true"
      >
        <div
          class="order-request-cards-shimmer__line order-request-cards-shimmer__line--title"
        ></div>
        <div class="order-request-cards-shimmer__line order-request-cards-shimmer__line--sub"></div>
      </div>
    </div>
  </ng-template>
</div>
